import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';
import { memo } from 'react';

import { useRootStyles } from './InitialsIcon.styles.js';
import type { InitialsIconProps } from './InitialsIcon.types.js';
import { stringToInitials } from './InitialsIcon.utils.js';

export const InitialsIcon: FC<InitialsIconProps> = memo(
  ({ text, color, size, type = 'circle', variant, ...props }) => {
    const rootStyles = useRootStyles({
      color,
      size,
      variant,
      text,
      type,
    });

    return (
      <Avatar component="div" {...props} sx={rootStyles}>
        <Typography variant="body1">{stringToInitials(text)}</Typography>
      </Avatar>
    );
  },
);

InitialsIcon.displayName = 'InitialsIcon';
